import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {
  BodySmall,
  BodyMediumBold,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {TimelineItem} from '@spaced-out/ui-design-system/lib/components/Timeline';
import css from './sequential-booking-info.css';


interface BreakTimelineItemProps {
  breakAmount: number;
  breakUnit: string;
  index: number;
}

export const BreakTimelineItem = ({
  breakAmount,
  breakUnit,
  index,
}: BreakTimelineItemProps) => {
  const {t} = useLabelTranslation();

  return (
    <TimelineItem
      children={null}
      key={`break-${index}`}
      classNames={{
        icon: css.timelineItemIcon,
      }}
      iconColor="neutral"
      iconName="mug-saucer"
      iconType="regular"
      enableCardWrapper={false}
      title={<BodyMediumBold>{t('Break', 'Break')}</BodyMediumBold>}
      description={
        <BodySmall color="secondary">
          {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
          {`${breakAmount} ${breakUnit}`}
        </BodySmall>
      }
    />
  );
};
